module.exports = {
  DENY_CABINET_AUTH: ["5774de03bf6b551eda7b7864", "5774de03bf6b551eda7b78e5"],
  HIDE_ALIEN_CONTACTS: "5774de04bf6b551eda7b78e2",
  DENY_CONTACTS_CHANGE: "5774de04bf6b551eda7b78e1",
  DENY_SMS_SEND: "5774de04bf6b551eda7b78df",
  DENY_USER_MANAGEMENT: "5774de04bf6b551eda7b78e3",
  ALLOW_ALIEN_TASK_MANAGEMENT: "5774de04bf6b551eda7b78e4",
  MONITORING: "63a427bbf15676aaadefe885"
}